
import request from '@/utils/request'
//查询
export function settlementQueryPage(data) {
    return request({
        url: '/icps/system/sign/dataCollection/settlementAdjustment/queryPage',
        method: 'POST',
        data
    })
}

//添加
export function saveOrUpdate(data) {
    return request({
        url: '/icps/system/sign/dataCollection/settlementAdjustment/saveOrUpdate',
        method: 'POST',
        data
    })
}
//删除
export function deleteOne(data) {
    return request({
        url: '/icps/system/sign/dataCollection/settlementAdjustment/deleteOne',
        method: 'POST',
        data
    })
}
